module.exports = __webpack_public_path__ + "img/IMG_9621_L_Black.48ae988a.jpg";